import React from "react";
import { IAddCategory } from "../../Category.props";
import { useForm } from "react-hook-form";
import { CancelButton, FormButton } from "../../../../components/Botton/index";
import Loader from "../../../../components/Loader/index";
import useCategory from "./useAddCatgeory";

const AddCategory: React.FC = () => {
  const {
    formData,
    loading,
    handleChange,
    handleFileChange,
    handleSubmit,
    handleCancel,
  } = useCategory();

  const {
    register,
    handleSubmit: useFormSubmit,
    formState: { errors },
  } = useForm<IAddCategory>();

  const fields = [
    { label: "Category", name: "category", type: "text" },
    { label: "Icon", name: "icon", type: "file" },
  ] as const;

  return (
    <div className="flex flex-col items-center w-full h-screen p-8">
      <div className="bg-white shadow-md rounded-lg pt-6 pb-6 w-full">
        <div className="border-b-2 w-[100%]">
          <h1 className="text-3xl mb-2 text-gray-700 ml-5">Add Category</h1>
        </div>
        {loading && <Loader />}
        <form onSubmit={useFormSubmit(handleSubmit)} className="space-y-6">
          <fieldset className="m-2 rounded border-opacity-60 bg-white">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 m-4">
              {fields.map((field) => (
                <div key={field.name}>
                  <label
                    className="block text-gray-700 text-base font-semibold mb-2"
                    htmlFor={field.name}
                  >
                    {field.label}:
                  </label>
                  {field.type === "file" ? (
                    <input
                      className="appearance-none border rounded w-full py-2 px-3 text-gray-600 leading-tight focus:outline-none focus:shadow-outline"
                      type={field.type}
                      id={field.name}
                      onChange={handleFileChange}
                    />
                  ) : (
                    <input
                      className="appearance-none border rounded w-full py-2 px-3 text-gray-600 leading-tight focus:outline-none focus:shadow-outline"
                      type={field.type}
                      id={field.name}
                      {...register(field.name, { required: true })}
                      value={formData[field.name]}
                      onChange={handleChange}
                    />
                  )}
                  {(errors[field.name] as any) && (
                    <span className="text-red-500 text-xs italic">
                      {field.label} field is required
                    </span>
                  )}
                </div>
              ))}
            </div>
          </fieldset>
          <div className="flex justify-start mt-6 ml-10">
            <FormButton
              className="py-2 px-4 rounded mr-4"
              type="submit"
              children="ADD"
            />
            <CancelButton
              className="py-2 px-4 rounded"
              onClick={handleCancel}
              children="Cancel"
              type="button"
            />
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddCategory;
